<template>
  <div class="rc-reception-status">
    <div class="rc-container">
      <div class="title">
        <div class="line"></div>
        <h1>
          {{ $t('list-receptionist-page.header', { split: '/' }) }}
        </h1>
      </div>
      <div class="rc-filter">
        <div class="title-datetime">
          {{
            $t('list-receptionist-page.title-date-time', {
              split: '/'
            })
          }}:
        </div>
        <div class="rc-input-relative">
          <div class="date-picker-relative">
            <v-menu class="v-menu-custom">
              <template
                v-slot:activator="{ on, attrs }"
                class="date-picker-relative"
              >
                <v-dialog
                  ref="modal_birthday"
                  v-model="modal_birthday"
                  :return-value.sync="birthday"
                  persistent
                  max-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="prepend-icon-calendar"
                    >
                      mdi-calendar</v-icon
                    >
                  </template>
                  <v-date-picker
                    v-model="birthday"
                    :locale="getLocaleDatePicker()"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_birthday = false">
                      {{
                        $t('component.btn-cancle', {
                          split: '/'
                        })
                      }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.modal_birthday.save(birthday)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>

                <v-text-field
                  v-model="birthdayFormattedTextField"
                  :hint="getHint"
                  persistent-hint
                  v-bind="attrs"
                  v-on="on"
                  @blur="handleBirthdayFromTextField"
                  class="input-date-picker"
                  solo
                  hide-details="true"
                ></v-text-field>
              </template>
            </v-menu>
          </div>
          <span
            class="form-error-tip"
            v-if="
              $v.birthday.$invalid &&
              $v.birthday.$dirty &&
              !$v.birthday.required
            "
          >
            {{
              $t('validate.required', {
                split: '/'
              })
            }}
          </span>
          <span
            class="form-error-tip"
            v-if="!$v.birthdayFormattedTextField.birthdayFormatted"
          >
            {{
              $t('validate.date-invalid', {
                split: '/'
              })
            }}
          </span>
        </div>
        <v-btn class="rc-btn-filter" color="#E8320D" @click="showList()">{{
          $t('list-receptionist-page.btn-display', {
            split: '/'
          })
        }}</v-btn>
      </div>
      <div class="count-recepted">
        <span class="amount-text"
          >{{
            $t('list-receptionist-page.count-reception', {
              split: '/'
            })
          }}:</span
        >
        <span class="text-bold"> {{ getLengthListCheckIn }}</span>
        <span class="amount-text">
          {{
            $t('list-receptionist-page.receptionist-person-title', {
              split: '/'
            })
          }}
        </span>
      </div>

      <v-data-table
        :headers="headers"
        :items="
          tableData !== null &&
          typeof tableData !== 'undefined' &&
          tableData.length !== 0
            ? tableData
            : []
        "
        :items-per-page="50"
        class="elevation-1 app_table"
        :no-data-text="noDataText"
      >
        <template v-slot:[`item.applicant_id`]="{ item }">
          {{
            tableData
              .map(function (x) {
                return x.applicant_id;
              })
              .indexOf(item.applicant_id) + 1
          }}
        </template>

        <template v-slot:[`item.reception_date`]="{ item }">
          <span>
            {{ convertDateAndTime(item.created_at) }}
          </span>
        </template>
        <template v-slot:[`item.applicant_school_name`]="{ item }">
          <span>
            {{ convertSchoolName(item) }}
          </span>
        </template>
        <template v-slot:[`item.applicant_name`]="{ item }">
          <span>
            {{ convertName(item) }}
          </span>
        </template>

        <template v-slot:[`item.applicant_gender`]="{ item }">
          <span>
            {{ convertGender(item.applicant_gender) }}
          </span>
        </template>
      </v-data-table>
      <div class="widget-button py-5 text-center">
        <router-link tag="button" :to="pathHome + '/top'">
          <v-btn depressed outlined color="#e8320e" class="btn-back">
            {{
              $t('scan-success-page.back-to-top-page', {
                split: '/'
              })
            }}
          </v-btn>
        </router-link>
      </div>
    </div>

    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiAccount, mdiClose, mdiCalendar } from '@mdi/js';
import { dateFormated } from '@/validators/date';
import { required } from 'vuelidate/lib/validators';
import {
  DISPLAY,
  UN_DISPLAY,
  ITEM_PER_PAGE,
  TYPE_INFORMATION,
  TYPE_NOTIFICATION,
  LANG_CODE_JAPANESE,
  HINT_TEXT_DATE_JAPANESE,
  HINT_TEXT_DATE_VIETNAMESE,
  MALE,
  FEMALE
} from '@/common/constants';

import '@/style/common.scss';
import ScrollTopBtn from '@/components/ScrollTopBtn';

export default {
  name: 'Homepage',
  components: { ScrollTopBtn },
  data() {
    return {
      userIcon: mdiAccount,
      closeIcon: mdiClose,
      tableData: [],
      headers: [
        {
          text: this.$t('list-receptionist-page.table.no', {
            split: '/'
          }),

          align: 'start',
          sortable: false,
          value: 'applicant_id'
        },
        {
          text: this.$t('list-receptionist-page.table.time', {
            split: '/'
          }),

          align: 'start',
          sortable: false,
          value: 'reception_date'
        },
        {
          text: this.$t('list-receptionist-page.table.entry-no', {
            split: '/'
          }),
          align: 'center',
          value: 'applicant_entry_no'
        },
        {
          text: this.$t('list-receptionist-page.table.name', {
            split: '/'
          }),
          value: 'applicant_name'
        },

        {
          text: this.$t('list-receptionist-page.table.gender', {
            split: '/'
          }),
          value: 'applicant_gender'
        },
        {
          text: this.$t('list-receptionist-page.table.school-name', {
            split: '/'
          }),
          value: 'applicant_school_name'
        }
      ],

      dialog: false,
      dialogRequiry: false,
      itemDetail: null,
      displayCheckbox: false,
      noDataText: this.$t('table-no-data', {
        split: '/'
      }),

      calendarIcon: mdiCalendar,

      modal: false,

      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),

      birthday: new Date().toISOString().substr(0, 10),
      modal_birthday: false,
      birthdayFormattedTextField: this.formatDate(
        new Date().toISOString().substr(0, 10)
      )
    };
  },

  validations: {
    birthdayFormattedTextField: {
      birthdayFormatted: dateFormated('birthdayFormattedTextField')
    },
    birthday: {
      required
    }
  },

  methods: {
    convertTimeZone(datetime) {
      const event = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));

      event.toLocaleString('vi-VN', {
        timeZone: 'UTC'
      });
    },

    convertName(item) {
      return item.applicant_name;
    },
    convertSchoolName(item) {
      if (
        item.applicant_university_id == '0' ||
        item.applicant_university_id === null
      ) {
        return item.applicant_school_name;
      } else {
        const arr = this.m_university.filter(
          (ele) => ele.id === item.applicant_university_id
        );
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },
    convertGender(gender) {
      if (gender == FEMALE) {
        return this.$t('register-page.btn-gender.female', { split: '/' });
      } else if (gender == MALE) {
        return this.$t('register-page.btn-gender.male', { split: '/' });
      } else {
        return null;
      }
    },
    handleBirthdayFromTextField() {
      let string = '';
      const datetime = this.birthdayFormattedTextField;
      if (this.checkDateFormate(datetime)) {
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        } else {
          const [day, month, year] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        }
        this.birthday = string;
      }
    },

    openDialogRequiry() {
      this.dialogRequiry = true;
    },

    displayEventPeriod() {
      let stringDateTime = '';
      if (this.m_event !== null) {
        stringDateTime =
          this.convertDateAndTime(this.m_event.event_period_from) +
          ' ~ ' +
          this.convertDateAndTime(this.m_event.event_period_to);
      }

      return stringDateTime;
    },

    checkDisplayHr() {
      if (this.m_event !== null) {
        const {
          organizer_name_display,
          cooperator_display,
          sponsor_display,
          operator_display
        } = this.m_event;

        if (
          sponsor_display === this.UN_DISPLAY &&
          operator_display === this.UN_DISPLAY &&
          organizer_name_display === this.UN_DISPLAY &&
          cooperator_display === this.UN_DISPLAY
        ) {
          return false;
        }
      }
      return true;
    },

    checkDisplayContactTo() {
      if (this.m_event !== null) {
        const {
          contact_to_display,
          contact_mail_display,
          contact_phone_display,
          contact_address_display
        } = this.m_event;

        if (
          contact_to_display === this.UN_DISPLAY &&
          contact_mail_display === this.UN_DISPLAY &&
          contact_phone_display === this.UN_DISPLAY &&
          contact_address_display === this.UN_DISPLAY
        ) {
          return false;
        }
      }
      return true;
    },

    handleShowDetail(item) {
      this.itemDetail = Object.assign({}, item);
      this.dialog = true;

      if (item !== null && item.type_notification === TYPE_INFORMATION) {
        const info_log_applicant_id = item.id;

        this.displayCheckbox = item.display_flag == DISPLAY ? false : true;
        this.$store.dispatch('updateDisplayFlagInfoLogApplicant', {
          info_log_applicant_id
        });
      }

      if (item !== null && item.type_notification === TYPE_NOTIFICATION) {
        const notification_applicant_id = item.id;

        this.displayCheckbox = item.display_flag == DISPLAY ? false : true;
        this.$store.dispatch('updateReadFlagNotificationApplicant', {
          notification_applicant_id
        });
      }
    },
    handleCloseDialog() {
      if (
        this.itemDetail !== null &&
        this.itemDetail.display_flag !== null &&
        typeof this.itemDetail.display_flag !== 'undefined'
      )
        if (this.displayCheckbox === true) {
          this.$store.dispatch('updateDisplayFlagNotificationApplicant', {
            notification_applicant_id: this.itemDetail.id
          });
        }
      this.dialog = false;
    },

    handleCloseDialogRequiry() {
      this.dialogRequiry = false;
    },

    handleShowDialogRequiry() {
      this.dialogRequiry = true;
    },
    showList() {
      const data = {
        event_id: this.checkEvent.event_id,
        date: this.birthday,
        time_zone: this.m_event.time_zone
      };

      this.$store.dispatch('listReceptionCheckInApplicant', data);
    }
  },

  created() {
    this.DISPLAY = DISPLAY;
    this.UN_DISPLAY = UN_DISPLAY;
    this.ITEM_PER_PAGE = ITEM_PER_PAGE;
    this.TYPE_NOTIFICATION = TYPE_NOTIFICATION;
    this.TYPE_INFORMATION = TYPE_INFORMATION;

    const data = {
      event_id: this.checkEvent.event_id,
      date: this.birthday,
      time_zone: this.m_event.time_zone
    };

    this.$store.dispatch('listReceptionCheckInApplicant', data);
  },

  watch: {
    birthday: function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = val;
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('-');
          string = year + '/' + month + '/' + day;
        } else {
          const [year, month, day] = datetime.split('-');
          string = day + '/' + month + '/' + year;
        }
        this.birthdayFormattedTextField = string;
      }
    },
    '$i18n.locale': function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = this.birthday;
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('-');
          string = year + '/' + month + '/' + day;
        } else {
          const [year, month, day] = datetime.split('-');
          string = day + '/' + month + '/' + year;
        }
        this.birthdayFormattedTextField = string;

        this.noDataText = this.$t('table-no-data', { split: '/' });
        this.headers = [
          {
            text: this.$t('list-receptionist-page.table.no', {
              split: '/'
            }),

            align: 'start',
            sortable: false,
            value: 'applicant_id'
          },
          {
            text: this.$t('list-receptionist-page.table.time', {
              split: '/'
            }),

            align: 'start',
            sortable: false,
            value: 'reception_date'
          },
          {
            text: this.$t('list-receptionist-page.table.entry-no', {
              split: '/'
            }),
            align: 'center',
            value: 'applicant_entry_no'
          },
          {
            text: this.$t('list-receptionist-page.table.name', {
              split: '/'
            }),
            value: 'applicant_name'
          },

          {
            text: this.$t('list-receptionist-page.table.gender', {
              split: '/'
            }),
            value: 'applicant_gender'
          },
          {
            text: this.$t('list-receptionist-page.table.school-name', {
              split: '/'
            }),
            value: 'applicant_school_name'
          }
        ];
      }
    },
    dataListCheckIn: function (val) {
      if (val) {
        return (this.tableData = Object.assign([], val));
      }
    }
  },

  computed: {
    getLengthListCheckIn() {
      const arr = this.tableData;

      return arr.length;
    },
    getHint() {
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        return HINT_TEXT_DATE_JAPANESE;
      } else {
        return HINT_TEXT_DATE_VIETNAMESE;
      }
    },
    ...mapGetters({
      m_event: 'getEventData',
      profile: 'getProfile',
      dataListCheckIn: 'getDataListCheckInReception'
    })
  },

  mounted() {
    // this.birthday = "2020-02-02";
  }
};
</script>

<style lang="scss">
@import '@/style/common.scss';
@import '@/style/devices.scss';
// @import "@/style/styleGuild.scss";
.rc-reception-status {
  .amount-text {
    color: #e8320d;
  }
  .text-bold {
    font-weight: 600;
  }
  .rc-filter {
    margin-bottom: 40px;

    .rc-input-relative {
      position: relative;
    }
    .rc-btn-filter {
      margin-left: 20px;
      height: 40px !important;
      color: #fff;
    }
    .title-datetime {
      width: auto;
      white-space: nowrap;
      margin-right: 20px;
    }
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .input-date-picker {
      .v-input__control {
        min-height: 40px !important;
      }
      position: relative !important;

      input {
        padding-left: 40px;
      }
    }
    .prepend-icon-calendar {
      position: absolute;
      z-index: 20;
      top: 12px;
      left: 12px;
    }

    .date-picker-relative {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      max-width: 250px;
    }
  }

  .count-recepted {
    margin-bottom: 20px;
  }

  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .rc-container {
    width: 80vw;
    margin-top: 50px;
    .title {
      margin-bottom: 80px;
    }
    .rc-datetime {
      color: #e8320d;
      font-size: 14px;
      text-align: center;
    }
    .rc-count-checkin {
      color: #e8320d;
      font-size: 14px;
      text-align: center;
      margin: 10px auto;
    }

    .rc-count-checkin-icon {
      display: none;
      color: #e8320d;
      font-size: 14px;
      text-align: center;
      margin: 10px auto;
    }

    .code-container {
      background: $secondary_blue;
      padding: 24px 0;
      display: flex;
      justify-content: center;

      .code {
        background: #fff;
        border-radius: 10px;
        border: 1px dashed $bold_blue;
        padding: 34px 60px;
        position: relative;
        z-index: 0;
        width: 140% !important;
        max-width: 550px;

        h3 {
          padding-bottom: 22px;
          border-bottom: 1px dashed $bold_blue;
        }

        .code-info {
          .v-btn {
            width: 350px;
            color: #fff;
            text-transform: unset !important;
          }
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .btn-code {
            margin-top: 50px;
          }
          .orderCode {
            color: #fff;
            width: 85%;
            height: 70px;
            font-weight: 900;
            font-size: 40px;
          }

          .title {
            font-weight: 500;
            font-size: 14px !important;
            margin-top: 40px;
            text-align: center;
          }

          .qr-box {
            overflow: hidden;
            background: #fff;
            box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            width: 50%;
            img {
              width: 100%;
            }
          }
        }
        .list-status {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}
@include tablet {
  .title {
    padding-top: 15px;
  }
}

@include mobile {
  .rc-reception-status {
    .rc-container {
      width: 90vw;
      .rc-datetime {
        margin-top: 25px !important;
      }
      .rc-count-checkin {
        display: none !important;
      }
      .rc-count-checkin-icon {
        display: block !important;
      }

      .code-container {
        padding: 50px 25px !important;
        height: calc(100vh - 50px);
        .code-info {
          .v-btn {
            width: 250px !important;
            color: #fff;
          }
        }
        .code {
          padding: unset !important;
        }
      }
    }
  }
}
</style>
